import { getAuthorizationToken } from 'site-modules/shared/utils/private-party/get-authorization-token';
import { PrivatePartyAPI } from 'client/data/api/api-client';
import { logger } from 'client/utils/logger/logger';

export const getPrivateListing = async () => {
  const authorization = await getAuthorizationToken();

  return PrivatePartyAPI.fetchJson(`/listings/user`, {
    method: 'GET',
    headers: { authorization, 'content-type': 'application/json' },
  })
    .then(response => response)
    .catch(e => {
      const errorMessage = e.message || e;
      logger.error(`Failed to get listings - ${errorMessage}`);
      return { isError: true, error: errorMessage };
    });
};
